<script setup>
/**
 * Imports
 */

/**
 * Props & Emits
 */
const props = defineProps({
  user: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(["update:user", "close"]);

/**
 * Variables
 */

/**
 * Methods
 */
function updateField() {
  emit("update:user", { ...props.user });
}
</script>

<template>
  <div class="profile-setting">
    <div class="profile-setting__top-main">
      <div class="profile-setting__avatar">
        <button @click.prevent class="profile-setting__avatar-change btn">
          <img src="/assets/images/ava.png" class="profile-setting__avatar-img" alt="" />
        </button>
      </div>
      <p class="profile-setting__name">Изменить</p>
    </div>
    <div class="profile-setting__info">
      <div class="profile-setting__info-item">
        <span class="profile-setting__info-item-title">Должность</span>
        <input
          class="profile-setting__info-item-value"
          type="text"
          :value="''"
          @input="updateField('jobTitle', $event.target.value)"
          placeholder="Введите должность"
        />
      </div>
      <div class="profile-setting__info-item">
        <span class="profile-setting__info-item-title">Фамилия</span>
        <input
          class="profile-setting__info-item-value"
          type="text"
          :value="''"
          @input="updateField('username', $event.target.value)"
          placeholder="Введите фамилию"
        />
      </div>
      <div class="profile-setting__info-item">
        <span class="profile-setting__info-item-title">Имя</span>
        <input
          class="profile-setting__info-item-value"
          type="email"
          :value="''"
          @input="updateField('email', $event.target.value)"
          placeholder="Введите имя"
        />
      </div>
      <div class="profile-setting__info-item">
        <span class="profile-setting__info-item-title">Отчество</span>
        <input
          class="profile-setting__info-item-value"
          type="email"
          :value="''"
          @input="updateField('email', $event.target.value)"
          placeholder="Введите отчество"
        />
      </div>
      <div class="profile-setting__info-item">
        <span class="profile-setting__info-item-title">Номер</span>
        <input
          class="profile-setting__info-item-value"
          type="email"
          :value="''"
          @input="updateField('email', $event.target.value)"
          placeholder="Введите номер"
        />
      </div>
      <button class="btn profile-setting__save">Сохранить</button>
    </div>
  </div>
</template>

<style lang="stylus">
.profile-setting__save {
  background-color: rgb(255, 65, 65) !important;
  color: rgb(255, 255, 255) !important;
  min-width: 198px;
  justify-content: center;
  height: 44px;
  margin: 8px 16px 8px 32px;
}
.profile-setting__top-main {
  display flex
  flex-direction column
  gap: 16px
  justify-content center
  align-items center
}
.profile-setting__avatar {
  border-radius 16px
}
.profile-setting {
  display flex
  border-radius: 16px;
  padding: 24px 16px
  flex-direction column
  gap: 32px

  &__top {
    display flex
    flex-direction column
    gap: 8px
  }

  &__name {
    font-size: 1.25rem
    line-height: normal;
  }

  &__avatar {
    display flex
    flex-direction column
    align-items flex-start
    gap: 8px

    &-img {
      width 200px
      height auto
      aspect-ratio 1 / 1
      flex-shrink 0
      border-radius 16px
    }

    &-change {
      padding: 2px 8px
      font-size: 0.875rem
      font-weight: 500;
      line-height: 1.42
      letter-spacing: -0.15px;
    }
  }

  &__info {
    display flex
    flex-direction column

    &-item {
      position relative
      padding: 8px 16px 8px 32px
      gap 8px
      display flex
      flex-direction column


      &-title {
        color: black;
        font-size: 0.875rem
        line-height: 1.33
        letter-spacing: 0.1px;
        padding: 5px 0
      }

      &-value {
        color #8F95A2
        background #F6F6F8
        padding: 10px
        border: none;
        outline: none;
        font: inherit;
        width: 100%;
        box-sizing: border-box;
      }

      &-btn.btn {
        width auto
        height 100%
        position absolute
        right 0
        top 50%
        transform translateY(-50%)
        z-index 1;

        .icon {
          width auto
          height 80%
          aspect-ratio 1 / 1
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .profile-setting__name {
    font-size 2.4rem
  }
  .profile-setting__info-item-title {
    font-size 1.6rem
  }
  .profile-setting__info-item-value {
    font-size 1.35rem
    padding 1.1rem 0.9rem
  }
  .profile-setting__info-item-btn {
    font-size 1.3rem
    min-width 60px
    min-height 60px
  }
  .profile-setting__avatar-img {
    width 200px
  }
}
@media (max-width: 800px) {
  .profile-setting__avatar-img {
    width 160px
  }
  .profile-setting__name {
    font-size 2rem
  }
  .profile-setting__info-item-title {
    font-size 1.3rem
  }
  .profile-setting__info-item-value {
    font-size 1.2rem
    padding 0.95rem 0.8rem
  }
  .profile-setting__info-item-btn {
    font-size 1.2rem
    min-width 52px
    min-height 52px
  }
}
@media (max-width: 600px) {
  .profile-setting__avatar-img {
    width 120px
  }
  .profile-setting__name {
    font-size 1.6rem
  }
  .profile-setting__info-item-title {
    font-size 1.1rem
  }
  .profile-setting__info-item-value {
    font-size 1.05rem
    padding 0.75rem 0.6rem
  }
  .profile-setting__info-item-btn {
    font-size 1.05rem
    min-width 40px
    min-height 40px
  }
}
@media (max-width: 420px) {
  .profile-setting__name {
    font-size 1.2rem
  }
  .profile-setting__info-item-title {
    font-size 1rem
  }
  .profile-setting__info-item-value {
    font-size 0.93rem
    padding 0.6rem 0.4rem
  }
  .profile-setting__info-item-btn {
    font-size 0.9rem
    min-width 32px
    min-height 32px
  }
  .profile-setting__avatar-img {
    width 80px
  }
}
@media (max-width: 350px) {
  .profile-setting__avatar-img {
    width 60px
  }
  .profile-setting__name {
    font-size 1rem
  }
  .profile-setting__info-item-title {
    font-size 0.85rem
  }
  .profile-setting__info-item-value {
    font-size 0.8rem
    padding 0.45rem 0.2rem
  }
  .profile-setting__info-item-btn {
    font-size 0.75rem
    min-width 24px
    min-height 24px
  }
}
</style>
